// Generated by KlangScriptProcessor, DO NOT EDIT
@file:Suppress("UNCHECKED_CAST", "UNUSED_PARAMETER", "UnusedImport")

package io.peekandpoke.klang.script.generated

import io.peekandpoke.klang.script.KlangScriptLibrary
import io.peekandpoke.klang.script.annotations.KlangScope
import io.peekandpoke.klang.script.ast.CallInfo
import io.peekandpoke.klang.script.builder.*
import io.peekandpoke.klang.script.runtime.*
import io.peekandpoke.klang.script.types.*

import io.peekandpoke.klang.audio_bridge.AdsrBuilder
import io.peekandpoke.klang.audio_bridge.BandFilterBuilder
import io.peekandpoke.klang.audio_bridge.EqBuilder
import io.peekandpoke.klang.audio_bridge.FilterBuilder
import io.peekandpoke.klang.audio_bridge.FmBuilder
import io.peekandpoke.klang.audio_bridge.IgnitorBandsBuilder
import io.peekandpoke.klang.audio_bridge.IgnitorDsl
import io.peekandpoke.klang.audio_bridge.KatalystBandsBuilder
import io.peekandpoke.klang.audio_bridge.KatalystBodyBuilder
import io.peekandpoke.klang.audio_bridge.KatalystBuilder
import io.peekandpoke.klang.audio_bridge.KatalystDelayBuilder
import io.peekandpoke.klang.audio_bridge.KatalystDsl
import io.peekandpoke.klang.audio_bridge.KatalystEqBuilder
import io.peekandpoke.klang.audio_bridge.KatalystKnobDsl
import io.peekandpoke.klang.audio_bridge.KatalystPhaserBuilder
import io.peekandpoke.klang.audio_bridge.KatalystRampBuilder
import io.peekandpoke.klang.audio_bridge.KatalystSawBuilder
import io.peekandpoke.klang.audio_bridge.KatalystSineBuilder
import io.peekandpoke.klang.audio_bridge.KatalystSquareBuilder
import io.peekandpoke.klang.audio_bridge.KatalystTriBuilder
import io.peekandpoke.klang.audio_bridge.KatalystVowelBuilder
import io.peekandpoke.klang.audio_bridge.ModAdsrBuilder
import io.peekandpoke.klang.audio_bridge.OscImpulseBuilder
import io.peekandpoke.klang.audio_bridge.OscPluckBuilder
import io.peekandpoke.klang.audio_bridge.OscPulzeBuilder
import io.peekandpoke.klang.audio_bridge.OscRampBuilder
import io.peekandpoke.klang.audio_bridge.OscSawBuilder
import io.peekandpoke.klang.audio_bridge.OscSineBuilder
import io.peekandpoke.klang.audio_bridge.OscSquareBuilder
import io.peekandpoke.klang.audio_bridge.OscSuperPluckBuilder
import io.peekandpoke.klang.audio_bridge.OscSuperRampBuilder
import io.peekandpoke.klang.audio_bridge.OscSuperSawBuilder
import io.peekandpoke.klang.audio_bridge.OscSuperSineBuilder
import io.peekandpoke.klang.audio_bridge.OscSuperSquareBuilder
import io.peekandpoke.klang.audio_bridge.OscSuperTriBuilder
import io.peekandpoke.klang.audio_bridge.OscTriBuilder
import io.peekandpoke.klang.audio_bridge.OscZampBuilder
import io.peekandpoke.klang.audio_bridge.OscZawtoothBuilder
import io.peekandpoke.klang.audio_bridge.PhaserBuilder
import io.peekandpoke.klang.audio_bridge.PitchEnvelopeBuilder
import io.peekandpoke.klang.audio_bridge.ShimmerBuilder
import io.peekandpoke.klang.audio_bridge.TremoloBuilder
import io.peekandpoke.klang.audio_bridge.VibratoBuilder
import io.peekandpoke.klang.common.SourceLocation
import io.peekandpoke.klang.script.runtime.ArrayValue
import io.peekandpoke.klang.script.runtime.BooleanValue
import io.peekandpoke.klang.script.runtime.NumberValue
import io.peekandpoke.klang.script.runtime.RuntimeValue
import io.peekandpoke.klang.script.runtime.StringValue
import io.peekandpoke.klang.script.stdlib.E
import io.peekandpoke.klang.script.stdlib.Ign
import io.peekandpoke.klang.script.stdlib.IgnitorDslLike
import io.peekandpoke.klang.script.stdlib.Kat
import io.peekandpoke.klang.script.stdlib.KlangScriptArrayExtensions
import io.peekandpoke.klang.script.stdlib.KlangScriptBooleanExtensions
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitor
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorAdsrCurvesSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorAdsrSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorBpfCurvesSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorBpfSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorCoarseSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorCrushSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorDistortSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorExtensions
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorFmSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorHpfCurvesSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorHpfSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorLpfCurvesSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorLpfSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorNotchCurvesSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorNotchSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorPenvCurvesSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorPenvSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorTremoloSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorVibratoSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalyst
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystBodySlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystCompressorSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystDelaySlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystDuckSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystGainSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystPhaserSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystReverbSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystVowelSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptMath
import io.peekandpoke.klang.script.stdlib.KlangScriptNumberExtensions
import io.peekandpoke.klang.script.stdlib.KlangScriptObjectUtility
import io.peekandpoke.klang.script.stdlib.KlangScriptStringExtensions
import io.peekandpoke.klang.script.stdlib.PI
import io.peekandpoke.klang.script.stdlib.scriptAbs
import io.peekandpoke.klang.script.stdlib.scriptAdd
import io.peekandpoke.klang.script.stdlib.scriptAdsr
import io.peekandpoke.klang.script.stdlib.scriptAnalog
import io.peekandpoke.klang.script.stdlib.scriptAnalogSpread
import io.peekandpoke.klang.script.stdlib.scriptBand
import io.peekandpoke.klang.script.stdlib.scriptBands
import io.peekandpoke.klang.script.stdlib.scriptBlend
import io.peekandpoke.klang.script.stdlib.scriptBody
import io.peekandpoke.klang.script.stdlib.scriptBrightness
import io.peekandpoke.klang.script.stdlib.scriptCap
import io.peekandpoke.klang.script.stdlib.scriptCenterJitter
import io.peekandpoke.klang.script.stdlib.scriptClassic
import io.peekandpoke.klang.script.stdlib.scriptCompressor
import io.peekandpoke.klang.script.stdlib.scriptCurves
import io.peekandpoke.klang.script.stdlib.scriptCut
import io.peekandpoke.klang.script.stdlib.scriptDeclick
import io.peekandpoke.klang.script.stdlib.scriptDelay
import io.peekandpoke.klang.script.stdlib.scriptDistort
import io.peekandpoke.klang.script.stdlib.scriptDiv
import io.peekandpoke.klang.script.stdlib.scriptDuck
import io.peekandpoke.klang.script.stdlib.scriptDuty
import io.peekandpoke.klang.script.stdlib.scriptEnv
import io.peekandpoke.klang.script.stdlib.scriptEq
import io.peekandpoke.klang.script.stdlib.scriptFallFlank
import io.peekandpoke.klang.script.stdlib.scriptFeedback
import io.peekandpoke.klang.script.stdlib.scriptFlankSamples
import io.peekandpoke.klang.script.stdlib.scriptFloor
import io.peekandpoke.klang.script.stdlib.scriptFundamental
import io.peekandpoke.klang.script.stdlib.scriptGain
import io.peekandpoke.klang.script.stdlib.scriptGainJitter
import io.peekandpoke.klang.script.stdlib.scriptHarmonics
import io.peekandpoke.klang.script.stdlib.scriptHumanize
import io.peekandpoke.klang.script.stdlib.scriptLimiter
import io.peekandpoke.klang.script.stdlib.scriptMax
import io.peekandpoke.klang.script.stdlib.scriptMin
import io.peekandpoke.klang.script.stdlib.scriptMinus
import io.peekandpoke.klang.script.stdlib.scriptMul
import io.peekandpoke.klang.script.stdlib.scriptNeg
import io.peekandpoke.klang.script.stdlib.scriptNegate
import io.peekandpoke.klang.script.stdlib.scriptOctaves
import io.peekandpoke.klang.script.stdlib.scriptOversampleAtLeast
import io.peekandpoke.klang.script.stdlib.scriptOversampleBy
import io.peekandpoke.klang.script.stdlib.scriptParallel
import io.peekandpoke.klang.script.stdlib.scriptPartial
import io.peekandpoke.klang.script.stdlib.scriptPasses
import io.peekandpoke.klang.script.stdlib.scriptPhase
import io.peekandpoke.klang.script.stdlib.scriptPhasePool
import io.peekandpoke.klang.script.stdlib.scriptPhaser
import io.peekandpoke.klang.script.stdlib.scriptPickPosition
import io.peekandpoke.klang.script.stdlib.scriptPlus
import io.peekandpoke.klang.script.stdlib.scriptPow
import io.peekandpoke.klang.script.stdlib.scriptPower
import io.peekandpoke.klang.script.stdlib.scriptRange
import io.peekandpoke.klang.script.stdlib.scriptResetSamples
import io.peekandpoke.klang.script.stdlib.scriptReverb
import io.peekandpoke.klang.script.stdlib.scriptRiseFlank
import io.peekandpoke.klang.script.stdlib.scriptSerial
import io.peekandpoke.klang.script.stdlib.scriptShape
import io.peekandpoke.klang.script.stdlib.scriptShapeMax
import io.peekandpoke.klang.script.stdlib.scriptSideAtten
import io.peekandpoke.klang.script.stdlib.scriptSpread
import io.peekandpoke.klang.script.stdlib.scriptSpreadPower
import io.peekandpoke.klang.script.stdlib.scriptStiffness
import io.peekandpoke.klang.script.stdlib.scriptSub
import io.peekandpoke.klang.script.stdlib.scriptSuboctaves
import io.peekandpoke.klang.script.stdlib.scriptTap
import io.peekandpoke.klang.script.stdlib.scriptTimes
import io.peekandpoke.klang.script.stdlib.scriptVoices
import io.peekandpoke.klang.script.stdlib.scriptVowel

internal fun KlangScriptExtensionBuilder.registerStdlibKatalystBuildersChunk0() {

    // @TypeExtensions(KatalystBuilder::class) on KatalystBuilder
    registerExtensionMethodWithSpecs(
        receiver = KatalystBuilder::class,
        name = "classic",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystBuilder::class, loc)
        checkNoArgs(fn = "classic", args = args, location = loc)
        wrapAsRuntimeValue(typedReceiver.scriptClassic())
    }

    // @TypeExtensions(KatalystBuilder::class) on KatalystBuilder
    registerExtensionMethodWithSpecs(
        receiver = KatalystBuilder::class,
        name = "body",
        paramSpecs = listOf(
            ParamSpec(name = "wet", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "material", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "configure", kotlinType = Function1::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystBuilder::class, loc)
        checkArgsSize(fn = "body", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.scriptBody(
                wet = optArg(args, 0, Any::class, loc),
                material = optArg(args, 1, Any::class, loc),
                configure = optArg(args, 2, Function1::class, loc) as ((KatalystBodyBuilder) -> KatalystBodyBuilder)?,
            )
        )
    }

    // @TypeExtensions(KatalystBuilder::class) on KatalystBuilder
    registerExtensionMethodWithSpecs(
        receiver = KatalystBuilder::class,
        name = "vowel",
        paramSpecs = listOf(
            ParamSpec(name = "wet", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "vowel", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "configure", kotlinType = Function1::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystBuilder::class, loc)
        checkArgsSize(fn = "vowel", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.scriptVowel(
                wet = optArg(args, 0, Any::class, loc),
                vowel = optArg(args, 1, Any::class, loc),
                configure = optArg(args, 2, Function1::class, loc) as ((KatalystVowelBuilder) -> KatalystVowelBuilder)?,
            )
        )
    }

    // @TypeExtensions(KatalystBuilder::class) on KatalystBuilder
    registerExtensionMethodWithSpecs(
        receiver = KatalystBuilder::class,
        name = "delay",
        paramSpecs = listOf(
            ParamSpec(name = "wet", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "time", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "feedback", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "configure", kotlinType = Function1::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystBuilder::class, loc)
        checkArgsSize(fn = "delay", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.scriptDelay(
                wet = optArg(args, 0, Any::class, loc),
                time = optArg(args, 1, Any::class, loc),
                feedback = optArg(args, 2, Any::class, loc),
                configure = optArg(args, 3, Function1::class, loc) as ((KatalystDelayBuilder) -> KatalystDelayBuilder)?,
            )
        )
    }

    // @TypeExtensions(KatalystBuilder::class) on KatalystBuilder
    registerExtensionMethodWithSpecs(
        receiver = KatalystBuilder::class,
        name = "reverb",
        paramSpecs = listOf(
            ParamSpec(name = "wet", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "size", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "lowpass", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystBuilder::class, loc)
        checkArgsSize(fn = "reverb", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.scriptReverb(
                wet = optArg(args, 0, Any::class, loc),
                size = optArg(args, 1, Any::class, loc),
                lowpass = optArg(args, 2, Any::class, loc),
            )
        )
    }

    // @TypeExtensions(KatalystBuilder::class) on KatalystBuilder
    registerExtensionMethodWithSpecs(
        receiver = KatalystBuilder::class,
        name = "phaser",
        paramSpecs = listOf(
            ParamSpec(name = "wet", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "rate", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "center", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "sweep", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "configure", kotlinType = Function1::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystBuilder::class, loc)
        checkArgsSize(fn = "phaser", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.scriptPhaser(
                wet = optArg(args, 0, Any::class, loc),
                rate = optArg(args, 1, Any::class, loc),
                center = optArg(args, 2, Any::class, loc),
                sweep = optArg(args, 3, Any::class, loc),
                configure = optArg(args, 4, Function1::class, loc) as ((KatalystPhaserBuilder) -> KatalystPhaserBuilder)?,
            )
        )
    }

    // @TypeExtensions(KatalystBuilder::class) on KatalystBuilder
    registerExtensionMethodWithSpecs(
        receiver = KatalystBuilder::class,
        name = "compressor",
        paramSpecs = listOf(
            ParamSpec(name = "threshold", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "ratio", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "knee", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "lookahead", kotlinType = Double::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystBuilder::class, loc)
        checkArgsSize(fn = "compressor", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.scriptCompressor(
                threshold = optArg(args, 0, Any::class, loc),
                ratio = optArg(args, 1, Any::class, loc),
                knee = optArg(args, 2, Any::class, loc),
                attack = optArg(args, 3, Any::class, loc),
                release = optArg(args, 4, Any::class, loc),
                lookahead = optArg(args, 5, Double::class, loc),
            )
        )
    }

    // @TypeExtensions(KatalystBuilder::class) on KatalystBuilder
    registerExtensionMethodWithSpecs(
        receiver = KatalystBuilder::class,
        name = "limiter",
        paramSpecs = listOf(
            ParamSpec(name = "threshold", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "ratio", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "knee", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "release", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "lookahead", kotlinType = Double::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystBuilder::class, loc)
        checkArgsSize(fn = "limiter", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.scriptLimiter(
                threshold = optArg(args, 0, Any::class, loc),
                ratio = optArg(args, 1, Any::class, loc),
                knee = optArg(args, 2, Any::class, loc),
                attack = optArg(args, 3, Any::class, loc),
                release = optArg(args, 4, Any::class, loc),
                lookahead = optArg(args, 5, Double::class, loc),
            )
        )
    }

    // @TypeExtensions(KatalystBuilder::class) on KatalystBuilder
    registerExtensionMethodWithSpecs(
        receiver = KatalystBuilder::class,
        name = "distort",
        paramSpecs = listOf(
            ParamSpec(name = "amount", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "shape", kotlinType = String::class, isOptional = true, default = { wrapAsRuntimeValue("soft") })
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystBuilder::class, loc)
        checkArgsSize(fn = "distort", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.scriptDistort(
                amount = optArg(args, 0, Any::class, loc),
                shape = if (args.size > 1) convertArgToKotlin(fn = "distort", args = args, index = 1, cls = String::class, nullable = false, loc = loc) as String else "soft",
            )
        )
    }

    // @TypeExtensions(KatalystBuilder::class) on KatalystBuilder
    registerExtensionMethodWithSpecs(
        receiver = KatalystBuilder::class,
        name = "duck",
        paramSpecs = listOf(
            ParamSpec(name = "orbit", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "depth", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
            ParamSpec(name = "attack", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystBuilder::class, loc)
        checkArgsSize(fn = "duck", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.scriptDuck(
                orbit = optArg(args, 0, Any::class, loc),
                depth = optArg(args, 1, Any::class, loc),
                attack = optArg(args, 2, Any::class, loc),
            )
        )
    }

    // @TypeExtensions(KatalystBuilder::class) on KatalystBuilder
    registerExtensionMethodWithSpecs(
        receiver = KatalystBuilder::class,
        name = "eq",
        paramSpecs = listOf(
            ParamSpec(name = "configure", kotlinType = Function1::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystBuilder::class, loc)
        checkArgsSize(fn = "eq", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.scriptEq(
                configure = optArg(args, 0, Function1::class, loc) as ((KatalystEqBuilder) -> KatalystEqBuilder)?,
            )
        )
    }

    // @TypeExtensions(KatalystBuilder::class) on KatalystBuilder
    registerExtensionMethodWithSpecs(
        receiver = KatalystBuilder::class,
        name = "gain",
        paramSpecs = listOf(
            ParamSpec(name = "gain", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(1.0) })
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystBuilder::class, loc)
        checkArgsSize(fn = "gain", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.scriptGain(
                gain = if (args.size > 0) convertArgToKotlin(fn = "gain", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any else 1.0,
            )
        )
    }

    // @TypeExtensions(KatalystBuilder::class) on KatalystBuilder
    registerExtensionMethodWithSpecs(
        receiver = KatalystBuilder::class,
        name = "plus",
        paramSpecs = listOf(
            ParamSpec(name = "other", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystBuilder::class, loc)
        checkArgsSize(fn = "plus", args = args, expected = 1, location = loc)
        val other = convertArgToKotlin(fn = "plus", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptPlus(other = other))
    }

    // @TypeExtensions(KatalystBuilder::class) on KatalystBuilder
    registerExtensionMethodWithSpecs(
        receiver = KatalystBuilder::class,
        name = "add",
        paramSpecs = listOf(
            ParamSpec(name = "other", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystBuilder::class, loc)
        checkArgsSize(fn = "add", args = args, expected = 1, location = loc)
        val other = convertArgToKotlin(fn = "add", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptAdd(other = other))
    }

    // @TypeExtensions(KatalystBuilder::class) on KatalystBuilder
    registerExtensionMethodWithSpecs(
        receiver = KatalystBuilder::class,
        name = "minus",
        paramSpecs = listOf(
            ParamSpec(name = "other", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystBuilder::class, loc)
        checkArgsSize(fn = "minus", args = args, expected = 1, location = loc)
        val other = convertArgToKotlin(fn = "minus", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptMinus(other = other))
    }

    // @TypeExtensions(KatalystBuilder::class) on KatalystBuilder
    registerExtensionMethodWithSpecs(
        receiver = KatalystBuilder::class,
        name = "sub",
        paramSpecs = listOf(
            ParamSpec(name = "other", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystBuilder::class, loc)
        checkArgsSize(fn = "sub", args = args, expected = 1, location = loc)
        val other = convertArgToKotlin(fn = "sub", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptSub(other = other))
    }

    // @TypeExtensions(KatalystBuilder::class) on KatalystBuilder
    registerExtensionMethodWithSpecs(
        receiver = KatalystBuilder::class,
        name = "times",
        paramSpecs = listOf(
            ParamSpec(name = "other", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystBuilder::class, loc)
        checkArgsSize(fn = "times", args = args, expected = 1, location = loc)
        val other = convertArgToKotlin(fn = "times", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptTimes(other = other))
    }

    // @TypeExtensions(KatalystBuilder::class) on KatalystBuilder
    registerExtensionMethodWithSpecs(
        receiver = KatalystBuilder::class,
        name = "mul",
        paramSpecs = listOf(
            ParamSpec(name = "other", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystBuilder::class, loc)
        checkArgsSize(fn = "mul", args = args, expected = 1, location = loc)
        val other = convertArgToKotlin(fn = "mul", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptMul(other = other))
    }

    // @TypeExtensions(KatalystBuilder::class) on KatalystBuilder
    registerExtensionMethodWithSpecs(
        receiver = KatalystBuilder::class,
        name = "div",
        paramSpecs = listOf(
            ParamSpec(name = "other", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystBuilder::class, loc)
        checkArgsSize(fn = "div", args = args, expected = 1, location = loc)
        val other = convertArgToKotlin(fn = "div", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptDiv(other = other))
    }

    // @TypeExtensions(KatalystBuilder::class) on KatalystBuilder
    registerExtensionMethodWithSpecs(
        receiver = KatalystBuilder::class,
        name = "neg",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystBuilder::class, loc)
        checkNoArgs(fn = "neg", args = args, location = loc)
        wrapAsRuntimeValue(typedReceiver.scriptNeg())
    }
}

internal fun KlangScriptExtensionBuilder.registerStdlibKatalystBuildersChunk1() {

    // @TypeExtensions(KatalystBuilder::class) on KatalystBuilder
    registerExtensionMethodWithSpecs(
        receiver = KatalystBuilder::class,
        name = "negate",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystBuilder::class, loc)
        checkNoArgs(fn = "negate", args = args, location = loc)
        wrapAsRuntimeValue(typedReceiver.scriptNegate())
    }

    // @TypeExtensions(KatalystBuilder::class) on KatalystBuilder
    registerExtensionMethodWithSpecs(
        receiver = KatalystBuilder::class,
        name = "abs",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystBuilder::class, loc)
        checkNoArgs(fn = "abs", args = args, location = loc)
        wrapAsRuntimeValue(typedReceiver.scriptAbs())
    }

    // @TypeExtensions(KatalystBuilder::class) on KatalystBuilder
    registerExtensionMethodWithSpecs(
        receiver = KatalystBuilder::class,
        name = "pow",
        paramSpecs = listOf(
            ParamSpec(name = "exp", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystBuilder::class, loc)
        checkArgsSize(fn = "pow", args = args, expected = 1, location = loc)
        val exp = convertArgToKotlin(fn = "pow", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptPow(exp = exp))
    }

    // @TypeExtensions(KatalystBuilder::class) on KatalystBuilder
    registerExtensionMethodWithSpecs(
        receiver = KatalystBuilder::class,
        name = "power",
        paramSpecs = listOf(
            ParamSpec(name = "exp", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystBuilder::class, loc)
        checkArgsSize(fn = "power", args = args, expected = 1, location = loc)
        val exp = convertArgToKotlin(fn = "power", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptPower(exp = exp))
    }

    // @TypeExtensions(KatalystBuilder::class) on KatalystBuilder
    registerExtensionMethodWithSpecs(
        receiver = KatalystBuilder::class,
        name = "min",
        paramSpecs = listOf(
            ParamSpec(name = "other", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystBuilder::class, loc)
        checkArgsSize(fn = "min", args = args, expected = 1, location = loc)
        val other = convertArgToKotlin(fn = "min", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptMin(other = other))
    }

    // @TypeExtensions(KatalystBuilder::class) on KatalystBuilder
    registerExtensionMethodWithSpecs(
        receiver = KatalystBuilder::class,
        name = "max",
        paramSpecs = listOf(
            ParamSpec(name = "other", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystBuilder::class, loc)
        checkArgsSize(fn = "max", args = args, expected = 1, location = loc)
        val other = convertArgToKotlin(fn = "max", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptMax(other = other))
    }

    // @TypeExtensions(KatalystBuilder::class) on KatalystBuilder
    registerExtensionMethodWithSpecs(
        receiver = KatalystBuilder::class,
        name = "serial",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystBuilder::class, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "serial", args = args, index = index, cls = Function1::class, nullable = true, loc = loc)
        } as List<((KatalystBuilder) -> KatalystBuilder)>
        wrapAsRuntimeValue(typedReceiver.scriptSerial(*kotlinArgs.toTypedArray()))
    }

    // @TypeExtensions(KatalystBuilder::class) on KatalystBuilder
    registerExtensionMethodWithSpecs(
        receiver = KatalystBuilder::class,
        name = "parallel",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystBuilder::class, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "parallel", args = args, index = index, cls = Function1::class, nullable = true, loc = loc)
        } as List<((KatalystBuilder) -> KatalystBuilder)>
        wrapAsRuntimeValue(typedReceiver.scriptParallel(*kotlinArgs.toTypedArray()))
    }

    // @TypeExtensions(KatalystBuilder::class) on KatalystBuilder
    registerExtensionMethodWithSpecs(
        receiver = KatalystBuilder::class,
        name = "oversampleBy",
        paramSpecs = listOf(
            ParamSpec(name = "factor", kotlinType = Int::class),
            ParamSpec(name = "body", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystBuilder::class, loc)
        checkArgsSize(fn = "oversampleBy", args = args, expected = 2, location = loc)
        val factor = convertArgToKotlin(fn = "oversampleBy", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val body = convertArgToKotlin(fn = "oversampleBy", args = args, index = 1, cls = Function1::class, nullable = false, loc = loc) as ((KatalystBuilder) -> KatalystBuilder)
        wrapAsRuntimeValue(typedReceiver.scriptOversampleBy(factor = factor, body = body))
    }

    // @TypeExtensions(KatalystBuilder::class) on KatalystBuilder
    registerExtensionMethodWithSpecs(
        receiver = KatalystBuilder::class,
        name = "oversampleAtLeast",
        paramSpecs = listOf(
            ParamSpec(name = "factor", kotlinType = Int::class),
            ParamSpec(name = "body", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystBuilder::class, loc)
        checkArgsSize(fn = "oversampleAtLeast", args = args, expected = 2, location = loc)
        val factor = convertArgToKotlin(fn = "oversampleAtLeast", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val body = convertArgToKotlin(fn = "oversampleAtLeast", args = args, index = 1, cls = Function1::class, nullable = false, loc = loc) as ((KatalystBuilder) -> KatalystBuilder)
        wrapAsRuntimeValue(typedReceiver.scriptOversampleAtLeast(factor = factor, body = body))
    }

    // @TypeExtensions(KatalystBuilder::class) on KatalystBuilder
    registerExtensionMethodWithSpecs(
        receiver = KatalystBuilder::class,
        name = "blend",
        paramSpecs = listOf(
            ParamSpec(name = "wet", kotlinType = Any::class),
            ParamSpec(name = "branch", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystBuilder::class, loc)
        checkArgsSize(fn = "blend", args = args, expected = 2, location = loc)
        val wet = convertArgToKotlin(fn = "blend", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        val branch = convertArgToKotlin(fn = "blend", args = args, index = 1, cls = Function1::class, nullable = false, loc = loc) as ((KatalystBuilder) -> KatalystBuilder)
        wrapAsRuntimeValue(typedReceiver.scriptBlend(wet = wet, branch = branch))
    }

    // @TypeExtensions(KatalystBuilder::class) on KatalystBuilder
    registerExtensionMethodWithSpecs(
        receiver = KatalystBuilder::class,
        name = "bands",
        paramSpecs = listOf(
            ParamSpec(name = "configure", kotlinType = Function1::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystBuilder::class, loc)
        checkArgsSize(fn = "bands", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.scriptBands(
                configure = optArg(args, 0, Function1::class, loc) as ((KatalystBandsBuilder) -> KatalystBandsBuilder)?,
            )
        )
    }

    // @TypeExtensions(KatalystKnobDsl::class) on KatalystKnobDsl
    registerExtensionMethodWithSpecs(
        receiver = KatalystKnobDsl::class,
        name = "plus",
        paramSpecs = listOf(
            ParamSpec(name = "other", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystKnobDsl::class, loc)
        checkArgsSize(fn = "plus", args = args, expected = 1, location = loc)
        val other = convertArgToKotlin(fn = "plus", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptPlus(other = other))
    }

    // @TypeExtensions(KatalystKnobDsl::class) on KatalystKnobDsl
    registerExtensionMethodWithSpecs(
        receiver = KatalystKnobDsl::class,
        name = "add",
        paramSpecs = listOf(
            ParamSpec(name = "other", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystKnobDsl::class, loc)
        checkArgsSize(fn = "add", args = args, expected = 1, location = loc)
        val other = convertArgToKotlin(fn = "add", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptAdd(other = other))
    }

    // @TypeExtensions(KatalystKnobDsl::class) on KatalystKnobDsl
    registerExtensionMethodWithSpecs(
        receiver = KatalystKnobDsl::class,
        name = "minus",
        paramSpecs = listOf(
            ParamSpec(name = "other", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystKnobDsl::class, loc)
        checkArgsSize(fn = "minus", args = args, expected = 1, location = loc)
        val other = convertArgToKotlin(fn = "minus", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptMinus(other = other))
    }

    // @TypeExtensions(KatalystKnobDsl::class) on KatalystKnobDsl
    registerExtensionMethodWithSpecs(
        receiver = KatalystKnobDsl::class,
        name = "sub",
        paramSpecs = listOf(
            ParamSpec(name = "other", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystKnobDsl::class, loc)
        checkArgsSize(fn = "sub", args = args, expected = 1, location = loc)
        val other = convertArgToKotlin(fn = "sub", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptSub(other = other))
    }

    // @TypeExtensions(KatalystKnobDsl::class) on KatalystKnobDsl
    registerExtensionMethodWithSpecs(
        receiver = KatalystKnobDsl::class,
        name = "times",
        paramSpecs = listOf(
            ParamSpec(name = "other", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystKnobDsl::class, loc)
        checkArgsSize(fn = "times", args = args, expected = 1, location = loc)
        val other = convertArgToKotlin(fn = "times", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptTimes(other = other))
    }

    // @TypeExtensions(KatalystKnobDsl::class) on KatalystKnobDsl
    registerExtensionMethodWithSpecs(
        receiver = KatalystKnobDsl::class,
        name = "mul",
        paramSpecs = listOf(
            ParamSpec(name = "other", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystKnobDsl::class, loc)
        checkArgsSize(fn = "mul", args = args, expected = 1, location = loc)
        val other = convertArgToKotlin(fn = "mul", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptMul(other = other))
    }

    // @TypeExtensions(KatalystKnobDsl::class) on KatalystKnobDsl
    registerExtensionMethodWithSpecs(
        receiver = KatalystKnobDsl::class,
        name = "div",
        paramSpecs = listOf(
            ParamSpec(name = "other", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystKnobDsl::class, loc)
        checkArgsSize(fn = "div", args = args, expected = 1, location = loc)
        val other = convertArgToKotlin(fn = "div", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptDiv(other = other))
    }

    // @TypeExtensions(KatalystKnobDsl::class) on KatalystKnobDsl
    registerExtensionMethodWithSpecs(
        receiver = KatalystKnobDsl::class,
        name = "pow",
        paramSpecs = listOf(
            ParamSpec(name = "exp", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystKnobDsl::class, loc)
        checkArgsSize(fn = "pow", args = args, expected = 1, location = loc)
        val exp = convertArgToKotlin(fn = "pow", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptPow(exp = exp))
    }

    // @TypeExtensions(KatalystKnobDsl::class) on KatalystKnobDsl
    registerExtensionMethodWithSpecs(
        receiver = KatalystKnobDsl::class,
        name = "power",
        paramSpecs = listOf(
            ParamSpec(name = "exp", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystKnobDsl::class, loc)
        checkArgsSize(fn = "power", args = args, expected = 1, location = loc)
        val exp = convertArgToKotlin(fn = "power", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptPower(exp = exp))
    }

    // @TypeExtensions(KatalystKnobDsl::class) on KatalystKnobDsl
    registerExtensionMethodWithSpecs(
        receiver = KatalystKnobDsl::class,
        name = "min",
        paramSpecs = listOf(
            ParamSpec(name = "other", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystKnobDsl::class, loc)
        checkArgsSize(fn = "min", args = args, expected = 1, location = loc)
        val other = convertArgToKotlin(fn = "min", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptMin(other = other))
    }

    // @TypeExtensions(KatalystKnobDsl::class) on KatalystKnobDsl
    registerExtensionMethodWithSpecs(
        receiver = KatalystKnobDsl::class,
        name = "max",
        paramSpecs = listOf(
            ParamSpec(name = "other", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystKnobDsl::class, loc)
        checkArgsSize(fn = "max", args = args, expected = 1, location = loc)
        val other = convertArgToKotlin(fn = "max", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptMax(other = other))
    }

    // @TypeExtensions(KatalystKnobDsl::class) on KatalystKnobDsl
    registerExtensionMethodWithSpecs(
        receiver = KatalystKnobDsl::class,
        name = "neg",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystKnobDsl::class, loc)
        checkNoArgs(fn = "neg", args = args, location = loc)
        wrapAsRuntimeValue(typedReceiver.scriptNeg())
    }

    // @TypeExtensions(KatalystKnobDsl::class) on KatalystKnobDsl
    registerExtensionMethodWithSpecs(
        receiver = KatalystKnobDsl::class,
        name = "negate",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystKnobDsl::class, loc)
        checkNoArgs(fn = "negate", args = args, location = loc)
        wrapAsRuntimeValue(typedReceiver.scriptNegate())
    }

    // @TypeExtensions(KatalystKnobDsl::class) on KatalystKnobDsl
    registerExtensionMethodWithSpecs(
        receiver = KatalystKnobDsl::class,
        name = "abs",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystKnobDsl::class, loc)
        checkNoArgs(fn = "abs", args = args, location = loc)
        wrapAsRuntimeValue(typedReceiver.scriptAbs())
    }

    // @TypeExtensions(KatalystKnobDsl::class) on KatalystKnobDsl
    registerExtensionMethodWithSpecs(
        receiver = KatalystKnobDsl::class,
        name = "range",
        paramSpecs = listOf(
            ParamSpec(name = "from", kotlinType = Any::class),
            ParamSpec(name = "to", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystKnobDsl::class, loc)
        checkArgsSize(fn = "range", args = args, expected = 2, location = loc)
        val from = convertArgToKotlin(fn = "range", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        val to = convertArgToKotlin(fn = "range", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptRange(from = from, to = to))
    }
}

internal fun KlangScriptExtensionBuilder.registerStdlibKatalystBuildersChunk2() {

    // @TypeExtensions(KatalystBodyBuilder::class) on KatalystBodyBuilder
    registerExtensionMethodWithSpecs(
        receiver = KatalystBodyBuilder::class,
        name = "floor",
        paramSpecs = listOf(
            ParamSpec(name = "floor", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystBodyBuilder::class, loc)
        checkArgsSize(fn = "floor", args = args, expected = 1, location = loc)
        val floor = convertArgToKotlin(fn = "floor", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptFloor(floor = floor))
    }

    // @TypeExtensions(KatalystVowelBuilder::class) on KatalystVowelBuilder
    registerExtensionMethodWithSpecs(
        receiver = KatalystVowelBuilder::class,
        name = "floor",
        paramSpecs = listOf(
            ParamSpec(name = "floor", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystVowelBuilder::class, loc)
        checkArgsSize(fn = "floor", args = args, expected = 1, location = loc)
        val floor = convertArgToKotlin(fn = "floor", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptFloor(floor = floor))
    }

    // @TypeExtensions(KatalystDelayBuilder::class) on KatalystDelayBuilder
    registerExtensionMethodWithSpecs(
        receiver = KatalystDelayBuilder::class,
        name = "cap",
        paramSpecs = listOf(
            ParamSpec(name = "cap", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystDelayBuilder::class, loc)
        checkArgsSize(fn = "cap", args = args, expected = 1, location = loc)
        val cap = convertArgToKotlin(fn = "cap", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptCap(cap = cap))
    }

    // @TypeExtensions(KatalystPhaserBuilder::class) on KatalystPhaserBuilder
    registerExtensionMethodWithSpecs(
        receiver = KatalystPhaserBuilder::class,
        name = "floor",
        paramSpecs = listOf(
            ParamSpec(name = "floor", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystPhaserBuilder::class, loc)
        checkArgsSize(fn = "floor", args = args, expected = 1, location = loc)
        val floor = convertArgToKotlin(fn = "floor", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptFloor(floor = floor))
    }

    // @TypeExtensions(KatalystSineBuilder::class) on KatalystSineBuilder
    registerExtensionMethodWithSpecs(
        receiver = KatalystSineBuilder::class,
        name = "phase",
        paramSpecs = listOf(
            ParamSpec(name = "phase", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystSineBuilder::class, loc)
        checkArgsSize(fn = "phase", args = args, expected = 1, location = loc)
        val phase = convertArgToKotlin(fn = "phase", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptPhase(phase = phase))
    }

    // @TypeExtensions(KatalystSawBuilder::class) on KatalystSawBuilder
    registerExtensionMethodWithSpecs(
        receiver = KatalystSawBuilder::class,
        name = "phase",
        paramSpecs = listOf(
            ParamSpec(name = "phase", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystSawBuilder::class, loc)
        checkArgsSize(fn = "phase", args = args, expected = 1, location = loc)
        val phase = convertArgToKotlin(fn = "phase", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptPhase(phase = phase))
    }

    // @TypeExtensions(KatalystRampBuilder::class) on KatalystRampBuilder
    registerExtensionMethodWithSpecs(
        receiver = KatalystRampBuilder::class,
        name = "phase",
        paramSpecs = listOf(
            ParamSpec(name = "phase", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystRampBuilder::class, loc)
        checkArgsSize(fn = "phase", args = args, expected = 1, location = loc)
        val phase = convertArgToKotlin(fn = "phase", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptPhase(phase = phase))
    }

    // @TypeExtensions(KatalystTriBuilder::class) on KatalystTriBuilder
    registerExtensionMethodWithSpecs(
        receiver = KatalystTriBuilder::class,
        name = "phase",
        paramSpecs = listOf(
            ParamSpec(name = "phase", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystTriBuilder::class, loc)
        checkArgsSize(fn = "phase", args = args, expected = 1, location = loc)
        val phase = convertArgToKotlin(fn = "phase", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptPhase(phase = phase))
    }

    // @TypeExtensions(KatalystSquareBuilder::class) on KatalystSquareBuilder
    registerExtensionMethodWithSpecs(
        receiver = KatalystSquareBuilder::class,
        name = "duty",
        paramSpecs = listOf(
            ParamSpec(name = "width", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystSquareBuilder::class, loc)
        checkArgsSize(fn = "duty", args = args, expected = 1, location = loc)
        val width = convertArgToKotlin(fn = "duty", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptDuty(width = width))
    }

    // @TypeExtensions(KatalystSquareBuilder::class) on KatalystSquareBuilder
    registerExtensionMethodWithSpecs(
        receiver = KatalystSquareBuilder::class,
        name = "phase",
        paramSpecs = listOf(
            ParamSpec(name = "phase", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(KatalystSquareBuilder::class, loc)
        checkArgsSize(fn = "phase", args = args, expected = 1, location = loc)
        val phase = convertArgToKotlin(fn = "phase", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.scriptPhase(phase = phase))
    }
}

